import * as React from "react"

import { SvgIconProps } from "styleguide/components/Svg/SvgIcon/SvgIcon"

import { Svg } from "styleguide/components"
import { uiColorToBaseColor } from "styleguide/styles/colors"

const IconTransparency = ({
  title = "Third party",
  color = "gray",
  viewBoxWidth = 40,
  viewBoxHeight = 40,
  ...otherProps
}: SvgIconProps) => (
  <Svg.Icon {...{ title, viewBoxHeight, viewBoxWidth, ...otherProps }}>
    <g fill="none" fillRule="evenodd">
      <circle fill={uiColorToBaseColor(color)} cx="20" cy="20" r="20" />
      <path
        d="M20 12c8.418 0 12 6.082 12 8 0 1.918-3.582 8-12 8S8 21.918 8 20c0-1.918 3.582-8 12-8zm0 2a6 6 0 100 12 6 6 0 000-12zm0 3a3 3 0 110 6 3 3 0 010-6z"
        fill="#FFF"
      />
    </g>
  </Svg.Icon>
)

export default IconTransparency
